import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";

/**
 * Confirmação ao trocar Empresa (projeto) com solicitação ainda aberta.
 * Avisa que a próxima mensagem do WhatsApp pode abrir solicitação nova.
 */
export default function ProjectChangeConfirmDialog({
  open,
  fromName,
  toName,
  onCancel,
  onConfirm,
  confirming = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={confirming ? undefined : onCancel}
      fullWidth
      maxWidth="sm"
      aria-labelledby="project-change-confirm-title"
    >
      <DialogTitle id="project-change-confirm-title">
        Trocar a empresa desta solicitação?
      </DialogTitle>
      <DialogContent dividers>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Esta solicitação ainda está em atendimento.
        </Alert>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Você está mudando de <strong>{fromName || "—"}</strong> para{" "}
          <strong>{toName || "—"}</strong>.
        </Typography>
        <Box
          component="ul"
          sx={{
            m: 0,
            pl: 2.5,
            "& li": { mb: 1 },
          }}
        >
          <Typography component="li" variant="body2">
            A próxima mensagem do cliente neste WhatsApp pode{" "}
            <strong>abrir uma solicitação nova</strong>, no projeto do canal.
          </Typography>
          <Typography component="li" variant="body2">
            Esta solicitação pode ficar para trás, sem receber as mensagens novas.
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Só confirme se for isso mesmo que você quer. Para só mudar o assunto, use o
          campo <strong>Tipo</strong> — ele não quebra a conversa.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onCancel} disabled={confirming} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          disabled={confirming}
          variant="contained"
          color="warning"
        >
          {confirming ? "Trocando…" : "Sim, trocar empresa"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
